import { Table, message, Button, Row, Col, Pagination, Image } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchProps from "../../../component/SearchProps";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";

export default function AttributeManage() {
  const [attribute, setAttribute] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });

  const fetchAttribute = async () => {
    await axiosInstance.get(`/attribute/getAll`, {params: pagination})
      .then((res) => {
        const data = res?.data;
        setAttribute(data);
      })
      .catch(() => message.error("Error server!"));
  };

  useEffect(() => {
    fetchAttribute();
  }, [pagination]);

  const columns = [
    {
      title: <div>ID</div>,
      key: "attribute_id",
      dataIndex: "attribute_id",
      width: 100,
      sorter: (a, b) => a.attribute_id - b.attribute_id,
      render: (_, record) => <div>{record?.attribute_id}</div>,
    },
    {
      title: <div>Tên thuộc tính</div>,
      key: "type",
      dataIndex: "type",
      width: 150,
      ...SearchProps("type"),
      render: (_, record) => <div>{record?.type}</div>,
    },
    {
      title: <div className={"base-table-cell-label "}>Ngày tạo</div>,
      key: "create_at",
      dataIndex: "create_at",
      width: 100,
      sorter: (a, b) => dayjs(a.create_at) - dayjs(b.create_at),
      render: (_, record) => {
        return (
          <div className={"cursor-pointer text-[14px] font-normal"}>
            <span className={"!inline-block min-w-[100px]"}>
              {dayjs(record?.create_at).format("DD/MM/YYYY")}
            </span>
          </div>
        );
      },
    },
    {
      key: "operation",
      dataIndex: "operation",
      width: 50,
      render: (_, record) => {
        return (
          <Link
            to={`/admin/quan-ly-thuoc-tinh/${record?.attribute_id}`}
            className={"text-[var(--blue)]"}
          >
            <EditOutlined />
          </Link>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <Row gutter={10} className={"mb-[8px]"}>
          <Col flex={1}>
            <div className={"text-[20px] font-medium"}>Quản lý thuộc tính</div>
          </Col>
          <Col>
            <Link to={"/admin/quan-ly-thuoc-tinh/tao-moi"}>
              <Button type={"primary"} onClick={() => {}}>
                Tạo
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="w-full h-full mt-5 pb-20 relative">
        <Table
          className={"custom-table"}
          dataSource={attribute?.data}
          columns={columns}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
        <Pagination
          className="flex justify-center absolute inset-x-0 bottom-10"
          current={pagination.page}
          total={attribute?.total}
          pageSize={pagination.pageSize}
          showSizeChanger
          onChange={(p, ps)=> {
            setPagination({
              page: p,
              pageSize: ps
            })
          }}
        />
      </div>
    </>
  );
}
